// extracted by mini-css-extract-plugin
export var activityContainer = "_mv-0";
export var typingIndicatorContainer = "_mv-1";
export var typingIndicatorDot = "_mv-2";
export var wave = "_mv-3";